"use client";

export { SessionProvider } from "next-auth/react";